<ng-container *ngIf="vm$ | async as vm">
	<div
		class="flex flex-col rounded-xl"
		[@openCloseWithState]="vm.showSearchSection ? 'open' : 'closed'"
	>
		<div *ngIf="owners$ | async as owners" class="flex flex-col gap-2 mb-4">
			<div *ngIf="owners.length > 0">Quick Search {{ vm.quickSearchText }}</div>

			<div class="flex gap-4">
				<ui-button
					*ngFor="let owner of owners"
					preset="MEDIUM_EMPHASIS"
					icon="search"
					[label]="
						owner.type === clientTypes.PERSON
							? owner.firstName + ' ' + owner.middleNames + ' ' + owner.lastName
							: owner.name
					"
					(click)="selectOwner(owner)"
					[testHook]="testHooks.SelectOwnerButton"
				></ui-button>
			</div>
		</div>

		<form
			(ngSubmit)="searchOwners(searchByOwnerForm)"
			#searchByOwnerForm="ngForm"
			class="flex flex-1 items-center pb-3"
			id="teranetForm"
		>
			<div class="flex">
				<div class="flex">
					<app-input
						[(ngModel)]="vm.firstName"
						name="firstName"
						label="Given name(s)"
						[testHook]="testHooks.FirstName"
					></app-input>
				</div>

				<div class="flex ml-5">
					<app-input
						[(ngModel)]="vm.lastName"
						[required]="true"
						[submitted]="vm.submitted"
						name="lastName"
						label="Last or corporate name"
						[testHook]="testHooks.LastOrCorporateName"
					></app-input>
				</div>

				<div class="flex items-end">
					<ui-button
						class="ml-5 mb-1"
						preset="HIGH_EMPHASIS"
						type="submit"
						teranetLoginGuard
						label="Search"
						[testHook]="testHooks.SearchButton"
					>
					</ui-button>
				</div>
			</div>
		</form>
	</div>

	<div *ngIf="!vm.loading" class="flex flex-1">
		<div
			*ngIf="vm.owners?.length === 0"
			class="flex flex-1 py-4 -mx-6 justify-center items-center bg-grey-lightest"
		>
			Unable to find any owners with the name {{ vm.firstName }}
			{{ vm.lastName }}
		</div>

		<div *ngIf="vm.owners?.length > 0" class="flex flex-col flex-1">
			<div
				class="flex flex-1 py-4 -mx-6 justify-center items-center bg-grey-lightest"
			>
				{{ vm.owners?.length }} Results For "{{ vm.firstName }}
				{{ vm.lastName }}"
			</div>

			<div class="flex flex-1 mt-6">
				<app-title-search-owners-table
					[owners]="vm.owners"
					(onSelectOwner)="onOwnerSelected($event)"
					class="flex flex-1 mr-4 w-1/4"
				></app-title-search-owners-table>
				<app-pins-table
					[pins]="vm.pins"
					[searching]="vm.searchingPins"
					[name]="vm.selectedName"
					[isOverview]="isOverview"
					class="flex w-3/4"
					[error]="vm.error"
					[searchingByOwners]="true"
				>
				</app-pins-table>
			</div>
		</div>
	</div>

	<div
		*ngIf="vm.loading"
		class="flex flex-1 py-4 -mx-6 justify-center items-center bg-grey-lightest"
	>
		...Searching
	</div>
</ng-container>
